import {
  useReviewPagination
} from "@/common/hooks/useReviewPagination"
import mergeOperations from "@/util/shallowMerge"
import {
  useLazyQuery
} from "@apollo/client"
import {
  usePathname
} from "next/navigation"
import {
  useEffect, useState
} from "react"
import DEFAULT_OPERATIONS from "./reviewsPage.gql"

export const useReviewsPage = (props) => {
  const {
    filterCategory, filterCategoryName, initialReviews
  } = props
  const operations = mergeOperations(DEFAULT_OPERATIONS, props.operations)
  const {
    getReciewPageQuery 
  } = operations
  const [paginationValues, paginationApi] = useReviewPagination({})

  const [filterCategoryCount, setFilterCategoryCount] = useState(0)

  const {
    currentPage, totalPages 
  } = paginationValues

  const {
    setCurrentPage, setTotalPages 
  } = paginationApi

  const pathname = usePathname()

  const [fetchReciewDetails, {
    called, data, loading 
  }] = useLazyQuery(
    getReciewPageQuery,
    {
      fetchPolicy: "cache-and-network",
      nextFetchPolicy: "cache-first",
    }
  )

  useEffect(() => {
    if (filterCategory) {
      fetchReciewDetails({
        variables: {
          category_id: filterCategory,
          currentPage: currentPage,
          pageSize: 30,
        },
      })
    }
  }, [fetchReciewDetails, currentPage, filterCategory])

  // 客户端查询未返回前，用服务端预取的 initialReviews 作初始数据，保证 SSR 渲染评价内容
  const reviewData = data?.allReviews ?? initialReviews
  const pagesize = reviewData ? reviewData.page_info.page_size : 0
  const reviewCount = reviewData ? reviewData.total_count : 0
  const pageCount = Math.ceil(reviewCount / pagesize)
  const totalPagesFromData = reviewData ? pageCount : null

  useEffect(() => {
    const itemCount = reviewData?.categories?.find((item) => item.id === filterCategory)?.count

    setFilterCategoryCount(itemCount)
  }, [filterCategory, reviewData])

  const pageControl = {
    currentPage,
    setPage: setCurrentPage,
    totalPages,
  }

  useEffect(() => {
    setTotalPages(totalPagesFromData)

    return () => {
      setTotalPages(null)
    }
  }, [setTotalPages, totalPagesFromData])

  return {
    reviewdata: reviewData,
    pageControl,
    filterCategory,
    loading,
    filterCategoryCount,
    filterCategoryName,
    pathname,
  }
}
